import { Toast as FlowbiteToast } from "flowbite-react";
export default FlowbiteToast;
